"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueCustomListMultiSelectDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useSelectedOption = require("../../utils/hooks/useSelectedOption");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _DropdownUtils = require("../../utils/components/DropdownUtils");
var _featureFlags = require("../../utils/featureFlags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const IssueCustomListMultiSelectDropdown = _ref => {
  let {
    attribute,
    value,
    onChange,
    container,
    ...props
  } = _ref;
  const {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase2Batch3);
  const options = (0, _react.useMemo)(() => attribute.metadata.list.options.map(_ref2 => {
    let {
      id,
      value
    } = _ref2;
    return {
      label: value,
      value: id
    };
  }), [attribute]);
  const selectedDropdownOptions = (0, _useSelectedOption.useReferentialSelectedOptions)(typeof value === "string" ? [value] : value || [], options);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const handleChange = (0, _react.useCallback)(selectedOptions => {
    onChange((selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(_ref3 => {
      let {
        value
      } = _ref3;
      return value;
    })) || null);
  }, [onChange]);
  const OldDropdown = () => /*#__PURE__*/_react.default.createElement(_SelectBoxWrapper.SelectBoxWrapper, _extends({
    multiple: true,
    placeholder: T.translate("customFieldsAdmin.placeholder.list"),
    clearable: true,
    options: options,
    value: selectedDropdownOptions,
    onChange: handleChange,
    container: container
  }, props));
  const semanticIdentifier = "project-member-multi-select-dropdown";
  const NewDropdown = () => {
    const {
      controlProps,
      menuProps
    } = (0, _alloyReactDropdown.useMultiDropdown)({
      items: options,
      selectedItems: selectedDropdownOptions,
      onSelectedItemsChange: _ref4 => {
        let {
          selectedItems
        } = _ref4;
        handleChange(selectedItems);
      },
      id: semanticIdentifier
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MultiControl, _extends({}, controlProps, {
      placeholder: T.translate("customFieldsAdmin.placeholder.list"),
      "data-testid": "".concat(semanticIdentifier, "-control")
    })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MultiSelectMenu, _extends({}, menuProps, {
      "data-testid": "".concat(semanticIdentifier, "-menu"),
      renderFooter: () => (0, _DropdownUtils.DropdownFooter)({
        isClearable: true,
        handleChange,
        shouldDisplay: (selectedDropdownOptions === null || selectedDropdownOptions === void 0 ? void 0 : selectedDropdownOptions.length) > 0
      })
    })));
  };
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.IssueCustomListMultiSelectDropdown = IssueCustomListMultiSelectDropdown;
//# sourceMappingURL=IssueCustomListMultiSelectDropdown.js.map